// Shared error state for widgets fetching from app-api (M2 slice 5).
//
// Shown when `useWidgetData` fails (non-2xx or transport). A generic message +
// a Retry that re-runs the query — identical across every widget, so the whole
// migration shares one error UX. Styling: `.bm-error` / `.bm-retry` in styles.css.

export interface WidgetErrorProps {
  /** Re-run the fetch (React Query's `refetch`). */
  onRetry: () => void;
}

export default function WidgetError({ onRetry }: WidgetErrorProps) {
  return (
    <div className="data-wrapper top-align">
      <div className="bm-error">
        Couldn’t load this data.
        <button type="button" className="bm-retry" onClick={onRetry}>
          Retry
        </button>
      </div>
    </div>
  );
}
